// extracted by mini-css-extract-plugin
module.exports = {"weight":"QuantityIcon_weight__KNJhW","icon":"QuantityIcon_icon__1RZPw","gramCount":"QuantityIcon_gramCount__MqN4x","gramLabel":"QuantityIcon_gramLabel__27bgY"};